var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.003,
    height: 10,
    viewBox: "0 0 10.003 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_40",
    "data-name": "Exclusion 40",
    d: "M-10737,3015a5.006,5.006,0,0,1-5-5,5.007,5.007,0,0,1,5-5,5.007,5.007,0,0,1,5,5A5.005,5.005,0,0,1-10737,3015Zm.534-8.1a2.583,2.583,0,0,0-1.835.751,2.552,2.552,0,0,0-.593,2.731l-1.219,1.219a4,4,0,0,0,1.461,1.507l1.261-1.259a2.485,2.485,0,0,0,.91.171,2.572,2.572,0,0,0,1.823-.767,2.541,2.541,0,0,0,.516-2.928l-1.742,1.7-1.191-1.186,1.705-1.7A2.653,2.653,0,0,0-10736.466,3006.9Z",
    transform: "translate(10742.002 -3005)",
    fill: "#e96a24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInService);
export default __webpack_public_path__ + "static/media/ic_in-service.96f465f55266d3f4c4cd160ece67f9a0.svg";
export { ForwardRef as ReactComponent };